import React from 'react'
import OffLine from '../off-line'

const OffLineSv = () => {
    return <OffLine languageCode="sv" />
}

export default OffLineSv
